export const albumWilliamMin = {
  albumTitle: "William & Min",
  albumDesc: "21 July 2017 in Delft, The Netherlands",
  photos: [
    "https://mir-s3-cdn-cf.behance.net/project_modules/2800/1d35f775852371.5c58b02982bbc.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/2800/91172b75852371.5c58b02981b3f.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/2800/32faaa75852371.5c58b029832fe.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/2800/7b25dc75852371.5c58b02981694.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/2800/13e64d75852371.5c58b02983a0e.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/2800/e50cd475852371.5c58b02982343.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/2800/d7997775852371.5c58b02983e87.jpg",
    "https://mir-s3-cdn-cf.behance.net/project_modules/2800/afd7e375852371.5c58b02981edb.jpg",
  ].map((imgUrl) => ({ src: imgUrl })),
};
